import React, { useEffect, useRef, useState } from "react";
import { Input } from "./Input";
import Model from "./Model";
import { Button } from "./Button";
import MasterTitle from "./MasterTitle";
import { ChevronUpDownIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import Pagination from "./Pagination";
import Records from "./Records";
import { SortData } from "./SortData";
import FloatNotification from "./FloatNotification";
import { PlusIcon, TrashIcon, QuestionMarkCircleIcon } from "@heroicons/react/20/solid";
import Select from "./Select";
import DeletePopup from "./DeletePopup";
import { Typography, FormControl } from "@mui/material";
import { Listbox } from "@headlessui/react";
import { ErrorToast, SuccessToast } from "./toast";
import { Api } from "../Api/Api";
import CircularProgress from "@mui/material/CircularProgress";
import NoDataFound from "./NoDataFound";
import { getDecryptedDataFromLocalStorage } from "../Api/encryption";
import ActionButton from "./ActionButton";
import { Checkbox } from "./Checkbox";
import { DocumentTextIcon } from "@heroicons/react/24/solid";

const BatchVideo = (props) => {
    const access = props?.access?.filter((e) => e?.name === "Youtube Video Name")?.[0] || { view: true, add: true, edit: true, delete: true };

    const [isModel, setIsModel] = useState(false);
    const [modelType, setModelType] = useState("");
    const [openModel, setOpenModel] = useState(false);
    const cancelButtonRef = useRef(null);
    const [isModelLoader, setisModelLoader] = useState(false);
    const [showFloatNotification, setShowFloatNotification] = useState(false);
    const [isHelpModel, setIsHelpModel] = useState(false);
    const [helpLink, setHelpLink] = useState("");
    const [helpId, setHelpId] = useState(null);
    const [isHelpLoading, setIsHelpLoading] = useState(false);
    const [filter, setFilter] = useState({
        board: { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" },
        medium: { id: 16, name: "Gujarati" },
        standard: "",
        subject: "",
    });
    const [search, setSearch] = useState("");
    const [isResetFilter, setIsResetFilter] = useState(false);
    const [selectAll, setSelectAll] = useState(false);

    const [titleData, setTitleData] = useState([
        { title: "SR NO.", sort: 1, fieldName: "id" },
        { title: "STANDARD", sort: 1, fieldName: "standard" },
        { title: "POSITION", sort: 1, fieldName: "position" },
        { title: "SUBJECT", sort: 1, fieldName: "subject" },
        { title: "TOPIC", sort: 1, fieldName: "topic" },
        { title: "VIDEO", sort: 1, fieldName: "videolink" },
        { title: "THUMBNAIL", sort: 1, fieldName: "thumbnail" },
        { title: "PDF", sort: 1, fieldName: "pdflink" },
        { title: "EDIT", sort: 1, fieldName: "" },
        { title: "DELETE", sort: 1, fieldName: "" },
    ]);

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(50);
    const [selectedId, setSelectedId] = useState(null);
    const [SelectTopicId, setSelectTopicId] = useState();
    const [TopicData, setTopicData] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [topicQuestion, setTopicQuestion] = useState({
        board: { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" },
        medium: { id: 16, name: "Gujarati" },
        standard: "",
        subject: "",
        topics: "",
        videoLink: "",
        thumbnail: "",
        pdfs: [], // Store file objects or existing URLs
        position: "",
    });
    const [pdfFields, setPdfFields] = useState([0]);
    const [pdfNames, setPdfNames] = useState([]); // Store filenames for display
    const [pdfPreviews, setPdfPreviews] = useState([]);
    const [thumbnailName, setThumbnailName] = useState("");

    const [dataCount, setDataCount] = useState(0);
    const [error, setError] = useState({});
    const lastIndex = (currentPage - 1) * recordsPerPage;
    const firstIndex = lastIndex;
    const npage = Math.ceil(dataCount / recordsPerPage);
    const numbers = [...Array(npage + 1).keys()].slice(1);
    const [checkedItems, setCheckedItems] = useState([]);
    const [deleteType, setDeleteType] = useState("single");

    const [boardData, setBoardData] = useState([]);
    const [mediumData, setMediumData] = useState([]);
    const [selectionDataStandard, setSelectionDataStandard] = useState([]);
    const [selectionDataSemester, setSelectionDataSemester] = useState([]);
    const [selectionDataSubject, setSelectionDataSubject] = useState([]);

    const [boardOutData, setBoardOutData] = useState([]);
    const [mediumOutData, setMediumOutData] = useState([]);
    const [standardOutData, setStandardOutData] = useState([]);
    const [semesterOutData, setSemesterOutData] = useState([]);
    const [subjectOutData, setSubjectOutData] = useState([]);

    const pdfFileInputRef = useRef(null);
    const otherFileInputRef = useRef(null);
    const videoFileInputRef = useRef(null);
    const blobUrlsRef = useRef([]);

    const registerBlobUrl = (url) => {
        if (url && url.startsWith("blob:")) {
            blobUrlsRef.current = [...blobUrlsRef.current, url];
        }
    };

    const revokeBlobUrl = (url) => {
        if (url && url.startsWith("blob:")) {
            URL.revokeObjectURL(url);
            blobUrlsRef.current = blobUrlsRef.current.filter((item) => item !== url);
        }
    };

    const clearAllBlobUrls = () => {
        blobUrlsRef.current.forEach((url) => {
            if (url && url.startsWith("blob:")) {
                URL.revokeObjectURL(url);
            }
        });
        blobUrlsRef.current = [];
    };

    const _getTopic = async (filter, search, limit, offset) => {
        try {
            setSelectAll(false);
            setIsLoader(true);
            const { data } = await Api.getRequest(
                `api/youtube-material?standard=${filter?.standard?.id || ""}&subject=${filter?.subject?.id || ""}&search=${search || ""}&limit=${limit || 50}&offset=${currentPage || 1}&isAdmin=true`
            );
            const req = JSON.parse(data);
            if (req?.status === 200) {
                setTopicData(req?.data);
                setDataCount(req?.totalCount);
            } else {
                ErrorToast(req?.message);
            }
        } catch (error) {
            ErrorToast(error?.message);
        } finally {
            setIsLoader(false);
        }
    };

    const validation = () => {
        let errors = {};
        let formIsValid = true;
        if (!topicQuestion?.board) { formIsValid = false; errors["board"] = "Please select board."; }
        if (!topicQuestion?.medium) { formIsValid = false; errors["medium"] = "Please select medium."; }
        if (!topicQuestion?.standard) { formIsValid = false; errors["standard"] = "Please select standard."; }
        if (!topicQuestion?.subject) { formIsValid = false; errors["subject"] = "Please select subject."; }
        if (!topicQuestion?.topics) { formIsValid = false; errors["topics"] = "Please enter topic."; }

        if (!topicQuestion?.videoLink && !topicQuestion?.thumbnail && topicQuestion?.pdfs?.filter(p => p).length === 0) {
            formIsValid = false;
            errors["file"] = "Please upload & enter at least one file or link.";
        }

        // Validate links (Must be HTTP/HTTPS)
        const urlPattern = /^https?:\/\/.+/;
        if (topicQuestion?.videoLink && !urlPattern.test(topicQuestion.videoLink)) {
            formIsValid = false;
            errors["videoLink"] = "Please enter a valid URL (starting with http/https).";
        }
        if (topicQuestion?.thumbnail && typeof topicQuestion.thumbnail !== "string") {
            const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
            if (!allowedTypes.includes(topicQuestion.thumbnail.type)) {
                formIsValid = false;
                errors["thumbnail"] = "Only PNG, JPG, and JPEG images are allowed.";
            }
        }

        setError(errors);
        return formIsValid;
    };

    const handleAddModelSubmit = async () => {
        let userData = getDecryptedDataFromLocalStorage("userData");
        let data, data1, data2, data3;
        if (validation()) {
            setIsLoading(true);
            try {
                if (topicQuestion["videoLink"] && typeof topicQuestion?.videoLink === 'string' && topicQuestion["videoLink"].includes("https://")) {
                    data = { data: topicQuestion["videoLink"], success: true };
                }

                let thumbLink = "";
                if (topicQuestion.thumbnail) {
                    if (typeof topicQuestion.thumbnail === "string" && topicQuestion.thumbnail.includes("https://")) {
                        thumbLink = topicQuestion.thumbnail;
                    } else {
                        let fd = new FormData();
                        fd.append("image", topicQuestion.thumbnail);
                        const res = await Api.axiospostRequest("api/upload/single_file", fd);
                        if (res.data?.data) thumbLink = res.data.data;
                    }
                }
                let pdflinks = [];
                for (let i = 0; i < topicQuestion.pdfs.length; i++) {
                    let file = topicQuestion.pdfs[i];
                    if (file) {
                        if (typeof file === 'string' && file.includes("https://")) {
                            pdflinks.push(file);
                        } else {
                            let fd = new FormData();
                            fd.append("image", file);
                            const res = await Api.axiospostRequest("api/upload/single_file", fd);
                            if (res.data?.data) pdflinks.push(res.data.data);
                        }
                    }
                }

                let body = {
                    board: topicQuestion?.board?.id,
                    medium: topicQuestion?.medium?.id,
                    standard: topicQuestion?.standard?.id,
                    subject: topicQuestion?.subject?.id,
                    topic: topicQuestion?.topics,
                    videolink: data?.data || topicQuestion?.videoLink || "",
                    thumbnaillink: thumbLink,
                    pdflink: pdflinks,
                    position: topicQuestion?.position,
                };

                let res;
                if (modelType === "edit") {
                    res = await Api.putRequest(`api/youtube-material/update/${selectedId}`, body);
                } else {
                    res = await Api.postRequest("api/youtube-material/create", body);
                }

                const req = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                if (req?.status === 200) {
                    SuccessToast(req?.message);
                    _getTopic(filter, search, recordsPerPage, currentPage);
                    setIsModel(false);
                    setTopicQuestion({
                        board: { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" },
                        medium: { id: 16, name: "Gujarati" },
                        standard: "",
                        subject: "",
                        topics: "",
                        videoLink: "",
                        thumbnail: "",
                        pdfs: [],
                        position: "",
                    });
                    setPdfNames([]);
                    setThumbnailName("");
                    clearAllBlobUrls();
                    setPdfPreviews([]);
                    setPdfFields([0]);
                    setSelectedId("");
                } else {
                    ErrorToast(req?.message || "Something went wrong");
                }
            } catch (error) {
                ErrorToast(error?.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const _getById = async (id) => {
        try {
            setisModelLoader(true);
            const { data } = await Api.getRequest(`api/youtube-material/${id}`);
            const req = JSON.parse(data);
            if (req?.status === 200 || req?.statusCode === 200) {
                const item = Array.isArray(req.data) ? req.data[0] : (req.data?.rows ? req.data.rows[0] : req.data);
                if (item) {
                    let pdflinks = item?.pdflink || [];
                    if (typeof pdflinks === 'string' && pdflinks.startsWith("[")) {
                        try { pdflinks = JSON.parse(pdflinks); } catch (e) { pdflinks = [pdflinks]; }
                    } else if (typeof pdflinks === 'string' && pdflinks) {
                        pdflinks = [pdflinks];
                    }

                    setTopicQuestion({
                        board: item?.StandardInfo?.boardInfo || item?.boardInfo || { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" },
                        medium: item?.StandardInfo?.mediumInfo || item?.mediumInfo || { id: 16, name: "Gujarati" },
                        standard: item?.StandardInfo || item?.standardInfo,
                        subject: item?.SubjectInfo || item?.subjectInfo,
                        topics: item?.topic || item?.topics || "",
                        videoLink: item?.videolink || item?.video || "",
                        thumbnail: item?.thumbnaillink || item?.thumbnail || "",
                        pdfs: pdflinks,
                        position: item?.position || "",
                    });

                    if (item?.StandardInfo?.id || item?.standardInfo?.id) getSubjectData(item?.StandardInfo?.id || item?.standardInfo?.id);

                    setPdfFields(pdflinks.map((_, i) => i).length > 0 ? pdflinks.map((_, i) => i) : [0]);
                    setPdfNames(pdflinks.map(p => p ? decodeURIComponent(p.split("/").pop()) : ""));
                    setPdfPreviews(pdflinks);
                    if (item?.thumbnaillink) setThumbnailName(decodeURIComponent(item.thumbnaillink.split("/").pop()));
                }
            }
        } catch (error) { ErrorToast(error?.message); }
        finally { setisModelLoader(false); }
    };

    const handleSelectAll = () => {
        if (selectAll) { setCheckedItems([]); }
        else { setCheckedItems(TopicData.map((d) => d.id)); }
        setSelectAll(!selectAll);
    };

    const handleCheckboxChange = (id) => {
        setDeleteType("multi");
        setCheckedItems((prev) => prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]);
    };

    const _deleteTopic = async () => {
        try {
            let ids = deleteType === "multi" ? checkedItems : [SelectTopicId];
            const response = await Api.postRequest(`api/youtube-material/delete`, { ids });
            const req = JSON.parse(response.data);
            if (req?.status === 200) {
                SuccessToast(req?.message);
                _getTopic(filter, search, recordsPerPage, currentPage);
                setOpenModel(false);
                setCheckedItems([]);
                setSelectAll(false);
            } else { ErrorToast(req?.message); }
        } catch (error) { ErrorToast(error?.message); }
    };

    const handleUploadChange = async (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== "application/pdf") {
            ErrorToast("Only PDF files are allowed.");
            e.target.value = "";
            return;
        }

        const fileName = file.name;

        let newPdfs = [...(topicQuestion.pdfs || [])];
        newPdfs[index] = file;
        setTopicQuestion({ ...topicQuestion, pdfs: newPdfs });

        if (pdfPreviews[index]) {
            revokeBlobUrl(pdfPreviews[index]);
        }

        const objectUrl = URL.createObjectURL(file);
        registerBlobUrl(objectUrl);

        let newPreviewUrls = [...(pdfPreviews || [])];
        newPreviewUrls[index] = objectUrl;
        setPdfPreviews(newPreviewUrls);

        let newNames = [...(pdfNames || [])];
        newNames[index] = decodeURIComponent(fileName);
        setPdfNames(newNames);

        e.target.value = "";
    };

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            ErrorToast("Only PNG, JPG, and JPEG images are allowed.");
            e.target.value = "";
            return;
        }

        setTopicQuestion({ ...topicQuestion, thumbnail: file, videoLink: "" });
        setThumbnailName(file.name);
        e.target.value = "";
    };

    const removeThumbnail = () => {
        setTopicQuestion({ ...topicQuestion, thumbnail: "" });
        setThumbnailName("");
    };

    const removeFile = (index) => {
        let newPdfs = [...(topicQuestion.pdfs || [])];
        newPdfs[index] = null;
        setTopicQuestion({ ...topicQuestion, pdfs: newPdfs });

        if (pdfPreviews[index]) {
            revokeBlobUrl(pdfPreviews[index]);
        }

        let newPreviewUrls = [...(pdfPreviews || [])];
        newPreviewUrls[index] = null;
        setPdfPreviews(newPreviewUrls);

        let newNames = [...(pdfNames || [])];
        newNames[index] = null;
        setPdfNames(newNames);

        if (index !== 0) {
            setPdfFields(prev => prev.filter(f => f !== index));
        }
    };

    const getBoardData = async () => {
        try { const { data } = await Api.getRequest(`api/board`); setBoardData(JSON.parse(data)?.data); setBoardOutData(JSON.parse(data)?.data); } catch (e) { }
    };
    const getMediumData = async (id) => {
        try { const { data } = await Api.getRequest(`api/medium?board=${id || ""}`); setMediumData(JSON.parse(data)?.data); setMediumOutData(JSON.parse(data)?.data); } catch (e) { }
    };
    const getStandardData = async (id) => {
        try {
            const { data } = await Api.getRequest(`api/standard?medium=${id || ""}`);
            const rawData = JSON.parse(data)?.data || [];
            const uniqueData = rawData.filter((v, i, a) => a.findIndex(t => (t.name === v.name)) === i);
            setSelectionDataStandard(uniqueData); setStandardOutData(uniqueData);
        } catch (e) { }
    };
    const getSemesterData = async (id) => {
        try { const { data } = await Api.getRequest(`api/v2/semester?standard=${id || ""}`); setSelectionDataSemester(JSON.parse(data)?.data?.rows); setSemesterOutData(JSON.parse(data)?.data?.rows); } catch (e) { }
    };
    const getSubjectData = async (id) => {
        try {
            const { data } = await Api.getRequest(`api/v2/subject?standard=${id || ""}`);
            const rawData = JSON.parse(data)?.data || [];
            const uniqueData = rawData.filter((v, i, a) => a.findIndex(t => (t.subject === v.subject)) === i);
            setSelectionDataSubject(uniqueData); setSubjectOutData(uniqueData);
        } catch (e) { }
    };

    const openPdfInNewTab = (url) => {
        if (typeof url === "string" && url) {
            window.open(url, "_blank", "noopener,noreferrer");
        }
    };

    const getHelpData = async () => {
        try {
            const { data } = await Api.getRequest(`api/helpvideo`);
            const req = JSON.parse(data);
            if (req?.status === 200) {
                const videoLink = Array.isArray(req?.data) ? req?.data[0]?.videolink : req?.data?.videolink;
                if (videoLink) {
                    setHelpLink(videoLink);
                }
            }
        } catch (e) { }
    };

    const handleHelpSubmit = async () => {
        if (!helpLink) return ErrorToast("Please enter help link");
        setIsHelpLoading(true);
        try {
            let body = { videolink: helpLink };
            const res = await Api.postRequest(`api/helpvideo/create`, body);
            const req = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            if (req?.status === 200) {
                SuccessToast("Help link updated successfully");
                setIsHelpModel(false);
                getHelpData();
            } else {
                ErrorToast(req?.message || "Failed to update help link");
            }
        } catch (e) { ErrorToast("Failed to update help link"); }
        finally { setIsHelpLoading(false); }
    };

    useEffect(() => { if (isHelpModel) getHelpData(); }, [isHelpModel]);

    useEffect(() => {
        getBoardData();
        getMediumData(44);
        getStandardData(16);
    }, []);
    useEffect(() => { if (selectedId) _getById(selectedId); }, [selectedId]);
    useEffect(() => {
        return () => {
            clearAllBlobUrls();
        };
    }, []);
    useEffect(() => { _getTopic(filter, search, recordsPerPage, currentPage); }, [currentPage, recordsPerPage]);

    const handelModelData = (name, value) => {
        let update = { [name]: value };
        if (name === "videoLink" && value) {
            update.thumbnail = "";
            setThumbnailName("");
        }
        if (name === "thumbnail" && value) update.videoLink = "";
        setTopicQuestion((old) => ({ ...old, ...update }));
        if (name === "board") getMediumData(value?.id);
        if (name === "medium") getStandardData(value?.id);
        if (name === "standard") { getSubjectData(value?.id); /* Reset sub */ setTopicQuestion(o => ({ ...o, subject: "" })); }
    };

    const handleFilter = (name, value) => {
        setFilter((old) => ({ ...old, [name]: value }));
        if (name === "board") getMediumData(value?.id);
        if (name === "medium") getStandardData(value?.id);
        if (name === "standard") { getSubjectData(value?.id); setFilter(o => ({ ...o, subject: "" })); }
    };

    const applyFilter = () => { setCurrentPage(1); _getTopic(filter, search, recordsPerPage, 1); };
    const resetFilter = () => {
        const defaultFilter = {
            board: { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" },
            medium: { id: 16, name: "Gujarati" },
            standard: "",
            subject: "",
        };
        setFilter(defaultFilter);
        setSearch("");
        setCurrentPage(1);
        _getTopic(defaultFilter, "", recordsPerPage, 1);
    };

    return (
        <div>
            <div className="h-full flex items-center justify-center ">
                <div className="h-full flex-1 flex flex-col space-y-5 lg:space-y-0 lg:flex-row lg:space-x-10 w-full sm:px-6 ">
                    <div className="flex-1 px-2 sm:px-0 w-full">
                        <div className="w-full mt-1 sm:px-0 flex md:flex-nowrap flex-wrap items-start gap-x-4 relative">
                            <div className="w-full"><Select data={boardOutData} value={filter.board} onChange={(e) => handleFilter("board", e)} placeholder="All Board" type="board" getBoard={getBoardData} disabled={true} hideIcon={true} /></div>
                            <div className="w-full"><Select data={mediumOutData} value={filter.medium} onChange={(e) => handleFilter("medium", e)} placeholder="All Medium" type="medium" getMedium={getMediumData} disabled={true} hideIcon={true} /></div>
                            <div className="w-full"><Select data={standardOutData} value={filter.standard} onChange={(e) => handleFilter("standard", e)} placeholder="All Standard" type="standard" getStandard={getStandardData} /></div>
                            <div className="w-full"><Select data={subjectOutData} value={filter.subject} onChange={(e) => handleFilter("subject", e)} placeholder="All Subject" type="subject" getSubject={() => getSubjectData(filter.standard?.id)} /></div>
                            <div className="mt-3"><Button onClick={applyFilter} label="SEARCH" /></div>
                            <div className="mt-3"><Button onClick={resetFilter} label="RESET" /></div>
                        </div>

                        <div className="flex justify-between items-center mt-2">
                            <MasterTitle title="Youtube Video Name" description="Below are the list of all the youtube video name." />
                            <div className="flex gap-2">
                                {access?.delete && (
                                    <Button icon={TrashIcon} type="submit" label="DELETE TOPIC" onClick={() => { setDeleteType("multi"); if (checkedItems.length > 0) setOpenModel(true); }} />
                                )}
                                {access?.add && (
                                    <Button icon={PlusIcon} type="submit" label="ADD YOUTUBE TOPIC" onClick={() => {
                                        setTopicQuestion({ board: { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" }, medium: { id: 16, name: "Gujarati" }, standard: "", subject: "", topics: "", videoLink: "", thumbnail: "", pdfs: [], position: "" });
                                        setPdfNames([]);
                                        setThumbnailName("");
                                        setPdfPreviews([]);
                                        setPdfFields([0]);
                                        setError({});
                                        setIsModel(true); setModelType("add");
                                    }} />
                                )}
                                <Button icon={QuestionMarkCircleIcon} variant="outlined" label="HELP" onClick={() => setIsHelpModel(true)} />
                            </div>
                        </div>

                        <section className="bg-white rounded-2xl flex flex-col shadow-sm mt-4 p-5 h-[75vh] relative z-0">
                            <div className="flex justify-between items-center px-8 mb-3">
                                <div className="flex gap-2">
                                    <Input placeholder="Search here..." className="w-72" onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }} value={search} />
                                    <Button onClick={applyFilter} searchicon={true} />
                                </div>
                                <Records recordsPerPage={recordsPerPage} setCurrentPage={setCurrentPage} setRecordsPerPage={setRecordsPerPage} dataCount={dataCount} />
                            </div>

                            <div className="overflow-auto h-[60vh] w-full">
                                {!isLoader && TopicData?.length <= 0 ? (
                                    <NoDataFound />
                                ) : (
                                    <table style={{ width: "100%" }}>
                                        <thead className="sticky top-0 bg-[#f4f7f8] z-10">
                                            <tr className="border-b text-left text-sm font-bold text-[#7B809A] uppercase bg-[#f4f7f8]">
                                                <th className="p-3 w-10 text-center" style={{ padding: "12px 24px" }}><Checkbox checked={selectAll} onChange={handleSelectAll} /></th>
                                                {titleData.map((v, i) => v.title && (
                                                    <th key={i} className="p-3" style={{
                                                        padding: "12px",
                                                        backgroundColor: "#f4f7f8",
                                                        position: v.title === "EDIT" || v.title === "DELETE" ? "sticky" : "",
                                                        right: v.title === "EDIT" ? "68px" : v.title === "DELETE" ? "0" : "",
                                                    }}>
                                                        <div className="flex justify-between items-center">
                                                            <span>{v.title}</span>
                                                            {v.title !== "EDIT" && v.title !== "DELETE" && <ChevronUpDownIcon className="w-5 h-5 cursor-pointer" onClick={() => setTopicData(SortData(TopicData, v.fieldName, v.sort))} />}
                                                        </div>
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y text-sm divide-gray-200">
                                            {isLoader ? (
                                                <tr style={{ height: "25rem" }}><td colSpan={14} className="text-center"><CircularProgress /></td></tr>
                                            ) : (
                                                TopicData.map((data, idx) => (
                                                    <tr key={idx} className="my-4 p-8 text-[#000] font-reguler text-sm font-medium">
                                                        <td className="px-6 py-3 whitespace-no-wrap"><Checkbox checked={checkedItems.includes(data.id)} onChange={() => handleCheckboxChange(data.id)} /></td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5">{data.id}</td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5">{data?.StandardInfo?.name}</td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5">{data?.position}</td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5">{data?.SubjectInfo?.subject}</td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5 font-medium">{data.topic}</td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5 text-blue-500 italic"><a href={data.videolink} target="_blank" rel="noreferrer" className="truncate block max-w-xs">{data.videolink}</a></td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5 text-blue-500 italic"><a href={data.thumbnaillink} target="_blank" rel="noreferrer" className="truncate block max-w-xs">{data.thumbnaillink}</a></td>
                                                        <td className="lg:table-cell whitespace-nowrap p-8 py-2.5 max-w-xs">
                                                            <div className="flex flex-col gap-1">
                                                                {Array.isArray(data.pdflink) ? (
                                                                    data.pdflink.map((link, i) => (
                                                                        <a key={i} href={link} target="_blank" rel="noreferrer" className="text-blue-500 hover:underline truncate block" title={link}>
                                                                            {link}
                                                                        </a>
                                                                    ))
                                                                ) : data.pdflink ? (
                                                                    <a href={data.pdflink} target="_blank" rel="noreferrer" className="text-blue-500 hover:underline truncate block" title={data.pdflink}>
                                                                        {data.pdflink}
                                                                    </a>
                                                                ) : "-"}
                                                            </div>
                                                        </td>
                                                        {access?.edit && (
                                                            <td className="relative whitespace-nowrap p-8 py-2.5 text-left sticky right-[68px] bg-white"><ActionButton action="edit" onClick={() => { setSelectedId(data.id); setIsModel(true); setModelType("edit"); }} /></td>
                                                        )}
                                                        {access?.delete && (
                                                            <td className="relative whitespace-nowrap p-6 py-2.5 text-left sticky right-0 bg-white"><ActionButton action="delete" onClick={() => { setDeleteType("single"); setSelectTopicId(data.id); setOpenModel(true); }} /></td>
                                                        )}
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} recordsPerPage={recordsPerPage} data={TopicData} dataCount={dataCount} firstIndex={firstIndex} npage={npage} numbers={numbers} />
                        </section>
                    </div>
                </div>
            </div>

            <Model
                title={modelType === "add" ? "Add Youtube Topic" : "Edit Youtube Topic"}
                show={isModel}
                onCancel={() => {
                    setIsModel(false);
                    setTopicQuestion({ board: { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" }, medium: { id: 16, name: "Gujarati" }, standard: "", subject: "", topics: "", videoLink: "", thumbnail: "", pdfs: [], position: "" });
                    setPdfNames([]);
                    setThumbnailName("");
                    setPdfPreviews([]);
                    setPdfFields([0]);
                    setError({});
                }}
                onClose={() => {
                    setIsModel(false);
                    setSelectedId("");
                    setTopicQuestion({ board: { id: 44, board_name: "GSEB (ગુજરાત બોર્ડ)" }, medium: { id: 16, name: "Gujarati" }, standard: "", subject: "", topics: "", videoLink: "", thumbnail: "", pdfs: [], position: "" });
                    setPdfNames([]);
                    setThumbnailName("");
                    setPdfPreviews([]);
                    setPdfFields([0]);
                    setError({});
                }}
                onOk={handleAddModelSubmit}
                okText="SUBMIT"
                cancelText="CLOSE"
                width="max-w-3xl"
                isLoading={isLoading}
            >
                {isModelLoader ? (
                    <div className="h-40 flex items-center justify-center"><CircularProgress /></div>
                ) : (
                    <div className="space-y-4">
                        <div className="grid grid-cols-2 gap-4 text-left">
                            <div className="flex flex-col"><Select label="Board" required data={boardData} value={topicQuestion.board} onChange={(v) => handelModelData("board", v)} type="board" getBoard={getBoardData} disabled={true} hideIcon={true} /></div>
                            <div className="flex flex-col"><Select label="Medium" required data={mediumData} value={topicQuestion.medium} onChange={(v) => handelModelData("medium", v)} type="medium" getMedium={getMediumData} disabled={true} hideIcon={true} /></div>
                            <div className="flex flex-col"><Select label="Standard" required data={selectionDataStandard} value={topicQuestion.standard} onChange={(v) => handelModelData("standard", v)} type="standard" getStandard={getStandardData} /><Typography variant="caption" color="error">{!topicQuestion?.standard ? error?.standard : ""}</Typography></div>
                            <div className="flex flex-col"><Select label="Subject" required data={selectionDataSubject} value={topicQuestion.subject} onChange={(v) => handelModelData("subject", v)} type="subject" getSubject={() => getSubjectData(topicQuestion.standard?.id)} /><Typography variant="caption" color="error">{!topicQuestion?.subject ? error?.subject : ""}</Typography></div>
                            <div className="flex flex-col">
                                <label className="mb-3 block text-sm font-medium text-[#252F40] font-poppins">Topic<span className="text-red-500"> *</span></label>
                                <input
                                    className="block w-full appearance-none rounded-md border border-gray-200 px-3 py-2 text-gray-900 placeholder-[#A0AEC0] focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm h-10"
                                    value={topicQuestion.topics || ""}
                                    onChange={(e) => handelModelData("topics", e.target.value)}
                                    placeholder="Type here..."
                                />
                                <Typography variant="caption" color="error">{!topicQuestion?.topics ? error?.topics : ""}</Typography>
                            </div>
                            <div className="flex flex-col">
                                <label className="mb-3 block text-sm font-medium text-[#252F40] font-poppins">Position</label>
                                <input
                                    className="block w-full appearance-none rounded-md border border-gray-200 px-3 py-2 text-gray-900 placeholder-[#A0AEC0] focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm h-10"
                                    value={topicQuestion.position || ""}
                                    onChange={(e) => handelModelData("position", e.target.value)}
                                    placeholder="Type here..."
                                />
                                <Typography variant="caption" color="error">{!topicQuestion?.position ? error?.position : ""}</Typography>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex flex-col">
                                <div className="flex flex-col">
                                    <label className="mb-3 block text-sm font-medium text-[#252F40] font-poppins">Add Video link</label>
                                    <input
                                        className={`block w-full appearance-none rounded-md border border-gray-200 px-3 py-2 text-gray-900 placeholder-[#A0AEC0] focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm h-10 ${!!thumbnailName || (!!topicQuestion.thumbnail && typeof topicQuestion.thumbnail !== 'string') ? 'bg-gray-100 cursor-not-allowed opacity-50' : ''}`}
                                        value={topicQuestion.videoLink || ""}
                                        onChange={(e) => handelModelData("videoLink", e.target.value)}
                                        placeholder="Type here..."
                                        disabled={!!thumbnailName || (!!topicQuestion.thumbnail && typeof topicQuestion.thumbnail !== 'string')}
                                    />
                                    <Typography variant="caption" color="error">{error?.videoLink}</Typography>
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <div className="flex justify-between items-center mb-1">
                                    <label className="text-sm font-medium text-[#252F40] font-poppins">Add Image</label>
                                </div>
                                <input
                                    type="file"
                                    id="thumbnail-upload"
                                    className="hidden"
                                    accept=".png,.jpg,.jpeg"
                                    onChange={handleThumbnailChange}
                                />
                                {thumbnailName ? (
                                    <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-md border border-gray-200 h-10 overflow-hidden mt-1 min-w-0">
                                        <span className="text-sm text-gray-600 truncate flex-1 font-medium italic" title={thumbnailName}>{thumbnailName}</span>
                                        <div className="flex-shrink-0">
                                            <TrashIcon className="h-4 w-4 text-red-500 cursor-pointer hover:text-red-600 transition-colors" onClick={removeThumbnail} />
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        onClick={() => !topicQuestion.videoLink && document.getElementById('thumbnail-upload').click()}
                                        className={`block w-full appearance-none rounded-md border border-gray-200 px-3 py-2 text-gray-400 sm:text-sm h-10 mt-1 ${!topicQuestion.videoLink ? 'cursor-pointer' : 'bg-gray-100 cursor-not-allowed opacity-50'}`}
                                    >
                                        Choose File
                                    </div>
                                )}
                                <Typography variant="caption" color="error">{error?.thumbnail}</Typography>
                            </div>
                        </div>
                        <div className="flex justify-center mt-[-10px]">
                            <Typography variant="caption" color="error">{(!topicQuestion?.videoLink && !topicQuestion?.thumbnail && topicQuestion?.pdfs?.filter(p => p).length === 0) ? error?.file : ""}</Typography>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex justify-between items-center mb-1">
                                <label className="text-sm font-medium text-[#252F40] font-poppins">Add PDF</label>
                                <div
                                    onClick={() => {
                                        const lastFieldIndex = pdfFields[pdfFields.length - 1];
                                        if (topicQuestion.pdfs[lastFieldIndex]) {
                                            setPdfFields(prev => [...prev, prev.length === 0 ? 0 : Math.max(...prev) + 1]);
                                        } else {
                                            ErrorToast("Please select a file before adding a new one.");
                                        }
                                    }}
                                    className="cursor-pointer bg-blue-500 text-white rounded-full p-0.5 hover:bg-blue-600 transition-colors"
                                >
                                    <PlusIcon className="h-4 w-4" />
                                </div>
                            </div>
                            <div className="space-y-3">
                                {pdfFields.map((field) => {
                                    const pdfValue = topicQuestion.pdfs[field];
                                    const previewUrl = pdfPreviews[field];
                                    const canPreview = Boolean(previewUrl) && Boolean(pdfNames[field]);
                                    return (
                                        <div key={field} className="flex items-center gap-2">
                                            <div className="flex-1 min-w-0">
                                                {pdfNames[field] ? (
                                                    <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-md border border-gray-200 h-10 overflow-hidden">
                                                        <span className="text-sm text-gray-600 truncate flex-1 font-medium" title={pdfNames[field]}>{pdfNames[field]}</span>
                                                    </div>
                                                ) : (
                                                    <div
                                                        onClick={() => document.getElementById(`pdf-upload-${field}`).click()}
                                                        className="block w-full appearance-none rounded-md border border-gray-200 px-3 py-2 text-gray-400 sm:text-sm h-10 cursor-pointer"
                                                    >
                                                        Choose File
                                                    </div>
                                                )}
                                                <input
                                                    type="file"
                                                    id={`pdf-upload-${field}`}
                                                    className="hidden"
                                                    accept=".pdf"
                                                    onChange={(e) => handleUploadChange(field, e)}
                                                />
                                            </div>
                                            <div className="flex items-center h-10 gap-2 flex-shrink-0">
                                                {canPreview && (
                                                    <button
                                                        type="button"
                                                        onClick={() => openPdfInNewTab(previewUrl)}
                                                        className="text-blue-500 hover:text-blue-600 transition-colors"
                                                        title="Open PDF in new tab"
                                                    >
                                                        <DocumentTextIcon className="h-4 w-4" />
                                                    </button>
                                                )}
                                                {pdfNames[field] && (
                                                    <TrashIcon className="h-4 w-4 text-red-500 cursor-pointer hover:text-red-600 transition-colors" onClick={() => removeFile(field)} />
                                                )}
                                                {!pdfNames[field] && field !== 0 && (
                                                    <TrashIcon className="h-4 w-4 text-red-500 cursor-pointer hover:text-red-600 transition-colors" onClick={() => removeFile(field)} />
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </Model>

            <DeletePopup
                show={openModel}
                title={deleteType === "single" ? "Delete Topic" : "Delete Multiple Topics"}
                description={`Are you sure you want to delete ${deleteType === "single" ? "this topic" : "these topics"}? All associated data will be permanently removed from our servers. This action cannot be undone.`}
                onCancel={() => setOpenModel(false)}
                onDelete={_deleteTopic}
            />

            <Model
                title="Help"
                show={isHelpModel}
                onCancel={() => setIsHelpModel(false)}
                onClose={() => setIsHelpModel(false)}
                onOk={handleHelpSubmit}
                okText="SUBMIT"
                cancelText="CLOSE"
                width="max-w-4xl"
                isLoading={isHelpLoading}
            >
                <div className="space-y-4">
                    <Input
                        label="Help Video Link"
                        value={helpLink}
                        onChange={(e) => setHelpLink(e.target.value)}
                        placeholder="Paste YouTube link here..."
                    />
                    {helpLink && (
                        <div className="w-full h-[500px] border rounded-lg overflow-hidden bg-black">
                            {helpLink.includes("youtube.com") || helpLink.includes("youtu.be") ? (
                                <iframe
                                    src={
                                        helpLink.includes("watch?v=")
                                            ? helpLink.replace("watch?v=", "embed/").split("&")[0]
                                            : helpLink.includes("youtu.be/")
                                                ? helpLink.replace("youtu.be/", "youtube.com/embed/")
                                                : helpLink
                                    }
                                    title="Help Video Preview"
                                    className="w-full h-full"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            ) : (
                                <iframe
                                    src={helpLink}
                                    title="Help Preview"
                                    className="w-full h-full"
                                />
                            )}
                        </div>
                    )}
                    {helpLink && (helpLink.includes("youtube.com") || helpLink.includes("youtu.be")) && (
                        <div className="text-center">
                            <a
                                href={helpLink}
                                target="_blank"
                                rel="noreferrer"
                                className="text-blue-500 hover:underline text-sm font-medium"
                            >
                                Can't see the video? Click here to watch on YouTube
                            </a>
                        </div>
                    )}
                </div>
            </Model>
        </div>
    );
};

export default BatchVideo;
